import BannerImage from '@onlineTraining/assets/banner-image.png';
import { OnlineCourseCategory } from '@onlineTraining/types/onlineTraining';
import { defineMessage, MessageDescriptor } from 'react-intl';

type OnlineTrainingCategoryTab = {
    value: OnlineCourseCategory | 'all';
    label: MessageDescriptor;
};

export const DEFAULT_ACTIVE_TAB: OnlineCourseCategory | 'all' = 'all';
export const PAGE_SIZE = 10;

export const ONLINE_TRAINING_CATEGORY_TABS: ReadonlyArray<OnlineTrainingCategoryTab> = [
    {
        value: DEFAULT_ACTIVE_TAB,
        label: defineMessage({ id: 'onlineTraining.categories.all', defaultMessage: 'All Courses' }),
    },
    {
        value: 'BT',
        label: defineMessage({ id: 'onlineTraining.categories.BT', defaultMessage: 'Beginner Training' }),
    },
    {
        value: 'TH',
        label: defineMessage({ id: 'onlineTraining.categories.TH', defaultMessage: 'Theory' }),
    },
    {
        value: 'AT',
        label: defineMessage({ id: 'onlineTraining.categories.AT', defaultMessage: 'Advanced Training' }),
    },
    {
        value: 'IE',
        label: defineMessage({ id: 'onlineTraining.categories.IE', defaultMessage: 'Installation Examples' }),
    },
];

export const ONLINE_TRAINING_BANNER = {
    background: 'dark' as const,
    headerTitle: defineMessage({
        id: 'onlineTraining.banner.headerTitle',
        defaultMessage: 'World-Class Victron Training, <blue>Anywhere, Anytime.</blue>',
    }),
    headerSuperscript: defineMessage({
        id: 'onlineTraining.banner.headerSuperscript',
        defaultMessage: 'Victron Energy Online Training',
    }),
    image: BannerImage,
    imageAlt: 'Victron Energy online training banner',
};
